import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { X } from "lucide-react";
import { accentBg } from "../../utils/accent";

/**
 * Casca do apoio rápido: header accent (padrão dos drawers do sistema),
 * trilha lateral clara à esquerda e área de trabalho branca à direita.
 */
export default function QuickCanvasModal({
  open,
  onClose,
  title,
  subtitle,
  icon: Icon,
  rail,
  children,
  testId,
  ...rest
}) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="flex flex-col max-w-[1000px] w-[calc(100vw-1.5rem)] h-[80vh] sm:h-[78vh] p-0 gap-0 border-0 overflow-hidden [&>button:last-child]:hidden"
        data-testid={testId}
        {...rest}
      >
        <div
          className="px-6 py-4 text-white flex items-center justify-between gap-3 shrink-0"
          style={accentBg()}
        >
          <div className="min-w-0">
            <DialogTitle className="text-base font-semibold flex items-center gap-2 truncate">
              {Icon && <Icon size={17} />}
              {title}
            </DialogTitle>
            {subtitle && (
              <p className="text-xs text-white/70 mt-0.5 truncate">{subtitle}</p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fechar"
            className="text-white/80 hover:text-white transition-colors shrink-0"
            data-testid="quick-canvas-close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex flex-1 min-h-0">
          <aside className="hidden sm:flex flex-col w-[210px] shrink-0 min-h-0 bg-gray-50/80 border-r border-gray-200">
            {rail}
          </aside>
          <section className="relative flex-1 min-w-0 min-h-0 flex flex-col bg-white">
            {children}
          </section>
        </div>
      </DialogContent>
    </Dialog>
  );
}
